<template>
    <EditCommandeFournisseur />
</template>

<script lang="ts">
    import EditCommandeFournisseur from "@/components/GesCom/CommandeFournisseur/EditCommandeFournisseur.vue";
    import { defineComponent } from "vue";

    export default defineComponent({
        name: "EditCommandeFournisseurPage",
        components: {
            EditCommandeFournisseur,
        },
    });
</script>